import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import QueryPage from './components/QueryPage';
import VerificationPage from './components/VerificationPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/verify" element={<VerificationPage />} />
          <Route path="/:query" element={<QueryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
